import { ConnectivityState } from "../../utils/helpers/constants";
import * as reduxConstants from '../../store/reduxConstants'
import { TWO_PLAYER_CONFIG } from "../../components/GamePlayComponents/constant";

export enum PLAYER_NUMBER {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}

export enum BOARD_TYPE {
  INVALID_BOARD = 0,
  DEFAULT_BOARD = 1,
  TRIO_BOARD = 2,
}
export interface IPositionalStyle {
  transform: [{ translateX: number }, { translateY: number }];
}

export enum DICE_BG_ALIGNMENT {
  LEFT = "left",
  RIGHT = "right",
}


// export const BOARD_CONFIG: { [key in BOARD_TYPE]?: IBoardConfig } = {
//   // [BOARD_TYPE.TRIO_BOARD]: THREE_PLAYER_CONFIG,
//   [BOARD_TYPE.DEFAULT_BOARD]: TWO_PLAYER_CONFIG
// }

export interface ICommonBox {
  playerNumber: PLAYER_NUMBER
  i: number
  isMovable: boolean
  score?: number
}


export interface IHomeBox {
  playerNumber: any;
  i: number
  isMovable: boolean
}

export interface IColoredBoxes {
  playerNumber: PLAYER_NUMBER
  positions: Array<number>
}

export interface IKukariPositionData {
  boardConfig: IBoardConfig
  commonBoxes: { [pos: number]: Array<ICommonBox> }
  homeBoxes: { [playerNumber in PLAYER_NUMBER]: { [pos: number]: Array<IHomeBox> } }
  finalBoxes: { [playerNumber in PLAYER_NUMBER]: Array<number> }
  coloredBoxes?: IColoredBoxes
}

export interface IPlayerUIConfig {
  containerStyle: IPositionalStyle;
  labelWrapperStyle: IPositionalStyle;
  infoIconWrapperStyle: IPositionalStyle;
  ppWrapperStyle: IPositionalStyle;
  diceWrapperStyle: IPositionalStyle;
  skipWrapperStyle: IPositionalStyle;
  coinStartLocation: ICoordinates;
  coinCenterLocation: ICoordinates;
  coinEndLocation: ICoordinates;
  moveStrBgStyle: IPositionalStyle;
  skipUpsideDown: boolean;
  PlayerNameBg?: React.FC<{ height?: number; width?: number }>;
  diceAlign: DICE_BG_ALIGNMENT;
  defaultDiceImage: string;
}

export interface ICoordinates {
  translateX: number;
  translateY: number;
  rotate?: string;
  zIndex?: number;
  direction?: string;
}

export interface IBoardConfig {
  PLAYER_UI_CONFIG: {
    [key in PLAYER_NUMBER]?: IPlayerUIConfig;
  };
  OUTER_PATH_LENGTH: number;
  PATH_FINAL_INDEX: number;
  HOME_PRIZE: number;
  HOME_KUKARI_SCORE: number;
  SAFE_POSITIONS: Array<number>;
  POSITIONS_BEFORE_LONG_STEP: Array<number>;
  HOME_LOTTIE_FILE?: {
    [key in PLAYER_NUMBER]?: string;
  };
  HOME_LOTTIE_FILE_HI?: {
    [key in PLAYER_NUMBER]?: string;
  };
  OTHER_PLAYER_HOME_PNG?: {
    [key in PLAYER_NUMBER]?: string
  }
  OTHER_PLAYER_HOME_PNG_HI?: {
    [key in PLAYER_NUMBER]?: string
  }
  START_POSITIONS: {
    [key in PLAYER_NUMBER]: number;
  };
  KUKARI_IMAGE: {
    [key in PLAYER_NUMBER]: String;
  };
  SMOKE_IMAGE?: {
    [key in PLAYER_NUMBER]?: String;
  };
  GLOW_IMAGE?: {
    [key in PLAYER_NUMBER]?: String;
  };
  DESTINY_IMAGE: {
    [key in PLAYER_NUMBER]?: string;
  };
  COMMON_BOXES: Array<ICoordinates>;
  HOME_BOXES: {
    [key in PLAYER_NUMBER]?: Array<ICoordinates>;
  };
  FINAL_BOXES: {
    [key in PLAYER_NUMBER]?: Array<ICoordinates>;
  };
  COLORED_PATH_COLOR?: {
    [key in PLAYER_NUMBER]?: string;
  };
}
export enum DICE_NUMBER {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
}

export enum NX_TIMER_TYPES {
  TURN = "TURN",
  BANK_SMALL = "BANK_SMALL",
  BANK_LARGE = "BANK_LARGE",
}

export type NX_TIMER_CONFIG = {
  [nxTimerType in NX_TIMER_TYPES]: {
    strokeLength: number;
    height: number;
    width: number;
    cx: number;
    cy: number;
    r: number;
    strokeWidth: number;
  };
};

export enum CONTEXTUAL_NUDGE_TYPE {
  SAFE = "safe",
  REACH_HOME = "rh",
  TOKEN_CUT = "tcut",
}

export interface IKuk {
  si: number;
  kukari: number;
}

export enum TTO_COUNT {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
}

export type LBAction = {
  type: keyof typeof reduxConstants
  [key: string]: any
}

export enum SocialReleation {
  NOT_FOLLOWING = "NOT_FOLLOWING",
  FOLLOWING = "FOLLOWING",
  SELF = "SELF",
}

export enum UserGameStatus {
  GAMES_PLAYED = "GAMES_PLAYED",
  GAMES_LOST = "GAMES_LOST",
  GAMES_WON = "GAMES_WON",
}

export type UserStat = {
  type: UserGameStatus;
  title: string;
  value: string;
};

export type SocialCTA = {
  displayText: string;
  type: string;
  value: string;
};

export type UserProfile = {
  user: {
    connections?: {
      followers: number;
      following: number;
    };
    zupeeUserId: string | number;
    username: string;
    imageUrl: string;
    socialRelation: SocialReleation;
    subCategory: string;
  };
  stats: Array<UserStat>;
  buttonCta: SocialCTA;
  cta: SocialCTA;
};

export interface IScoreFlyAnimationConfigForPlayer {
  initialPosition: ICoordinates;
  finalPosition: ICoordinates;
  playerNumber: PLAYER_NUMBER;
  score: number;
  timestamp?: number;
}

export interface IPlayerGameInfo {
  si?: number;
  uid?: string;
  scr?: number;
  profilePic?: string;
  name?: string;
}

export type TScoreFlyAnimationConfig = {
  [key in PLAYER_NUMBER]?: IScoreFlyAnimationConfigForPlayer | null;
};

export interface IPlayerInfo {
  dvp?: Array<number>;
  TCount?: TTO_COUNT;
  turnCount?: number;
  si: number;
  tbl: number;
  ui?: {
    pp?: string | null;
    un?: string | null;
    _id?: string | null;
    zupeeUserId?: number | null;
  };
  messages?: {
    en?: {
      userCurrStateText?: string;
    };
    hi?: {
      userCurrStateText?: string;
    };
  };
}

export interface IMovingKukari {
  playerNumber: PLAYER_NUMBER;
  tokenIndex: number;
  finalPosition: number;
}

export interface IKilledKukari {
  playerNumber: PLAYER_NUMBER;
  tokenIndex: number;
}

export interface ISmoke {
  playerNumber: PLAYER_NUMBER;
  tokenPosition: number;
}

export enum NX_HOME_ANIMATION_TYPE {
  NICE = "NICE",
  WELL_DONE = "WELL_DONE",
  GREAT_JOB = "GREAT_JOB",
  SHABASH = "SHABASH",
  BAHUT_BADHIYA = "BAHUT_BADHIYA",
  JABARDAST = "JABARDAST",
}

export interface IHomeAnimationConfig {
  // lottieFile: any;
  // animImage: any;
  nxHomeAnimationType: NX_HOME_ANIMATION_TYPE;
}

export interface IKukariMoveConfig {
  playerNumber: PLAYER_NUMBER;
  initialPosition: number;
  finalPosition: number;
  currentPosition: number;
}

export interface ITtoScreenData {
  title: string;
  description: string;
  ctaText: string;
}

export interface IPoolDistributionItem {
  label?: string;
  amt?: string;
}

export interface IQuickGuideRow {
  image?: string;
  text?: string;
}

export interface IQuickGuideItem {
  title?: string;
  rows?: Array<IQuickGuideRow>;
}

export interface ITextForGameFeedItem {
  startMove?: string;
  endMove?: string;
  text?: string;
  rightImage?: string;
  leftImage?: string;
  type?: string;
}

export interface IGameTimerNudgeStore {
  showAt: number;
  showFor: number;
  text: string;
}

export type IContextualNudgeItemInStore = Array<{
  initialPosition: number;
  finalPosition: number;
}>;

export interface IFTCPDataInStore {
  diceNudge?: {
    maxNudgeCount: number;
    text: string;
  };
  tokenNudge?: {
    maxNudgeCount: number;
    text: string;
  };
  maxCurrentUserTurnAnimation: number;
  maxOtherUserTurnAnimation: number;
  firstGameTimerNudge?: IGameTimerNudgeStore;
  lastGameTimerNudge?: IGameTimerNudgeStore;
  takeHomeNudge?: {
    showAfterPosition: number;
    showFor: number;
  };
  isVoiceOverEnabled: boolean;
}

export interface ITableInfo {
  _id: string | null;
  ltid: number | null;
  gtiAP: number | null;
  prizePot: number | null;
  gameTimer: number;
  gameClockUrl?: string | null;
  pi: Array<IPlayerInfo>;
  mySeatIndex: number | null;
  tst: number | null;
  shareCode: null;
  totalPlayers: number | null;
  isOpenShareModal: false;
  coinAnimation: boolean;
  bounceAnimation: boolean;
  smokeAnimation: boolean;
  startGameIcon: boolean;
  startDice: boolean | null;
  gameStartCountdown: number;
  leftPlayers: Array<string>;
  finalMovePlayers: Array<string> | null;
  finishingGame: boolean;
  pointsAnimation: boolean;
  tripleSixAnimation: boolean;
  turnSi: number | null;
  timeLeft: number | null;
  dv: number | null;
  IsTtsix: boolean | null;
  stt?: any;
  roundNo?: any;
  boardType?: any; 
  timeLimitInSecs?: any;
  turnCount?:any;
  enableHomeAnimation?: any;
  payoutDistribution: { [key: number]: number };
  entryFee: number | null;
  showProfileModal: boolean;
  showInternetIcon: boolean;
  showTurnTimer: boolean;
  internetConnectivity: (typeof ConnectivityState)[keyof typeof ConnectivityState];
  movingKukari?: IMovingKukari | any;
  killedKukari?: IKilledKukari | any;
  smoke?: ISmoke | null;
  homeAnimationConfig?: IHomeAnimationConfig | null;
  showGameTimeNudge: boolean;
  showGameStartNudge: boolean;
  showSkipBox: boolean;
  showWrongTurnAlert: boolean;
  skipSi: number | null;
  ftcpData: IFTCPDataInStore;
  currentPlayerTurnCount: number | null;
  kukariMoveConfig: IKukariMoveConfig | null;
  scoreFlyAnimationConfig?: TScoreFlyAnimationConfig | null;
  showTakeHomeNudge: boolean;
  roundNumber: number | null;
  tableStartTime: number | null;
  gameTimeLimitText: string | null;
  ttoScreenData: ITtoScreenData | null;
  skipCountForNudge: TTO_COUNT | null;
  tokenCutCN: IContextualNudgeItemInStore;
  reachHomeCN: IContextualNudgeItemInStore;
  safeCN: IContextualNudgeItemInStore;
  isPrizepoolTooltipVisible: boolean;
  isTNCBSVisible: boolean;
  timeBankTimeLeft: number;
  poolDistribution: Array<IPoolDistributionItem>;
  quickGuide: Array<IQuickGuideItem>;
  movesLeft: number;
  extraPointForHomeEnabled: boolean;
  textForGameFeed: Array<ITextForGameFeedItem>;
  playedTc: number;
  score: number;
  isTimeBankVisible: boolean;
  totalTimeBankTime: number;
  showGameEndNudge: boolean;
  pgi: IPlayerGameInfo;
  isKukariScoreVisible: boolean;
  isScoreRevealAnimationVisible: boolean;
  showExtraMoveNudge: boolean;
  isSkipTooltipVisible: boolean;
  maxWinners: number | null;
  resetTimer?: number | null
}

export interface ILudoboardState {
  tableInfo: ITableInfo;
  userProfile: {
    [userId: string]: UserProfile;
  };
}
